/**
 * ACTIVITY API — Endpoint bulk delle attività per entità (TS-59).
 *
 * Contratto backend (RelationshipsResourceImpl.getEntityActivities):
 * - GET /relationships/{groupId}/activities?className=<fqn>&classPK=<id>
 *     -> Page<ActivitySummary> (REST Builder incapsula le risposte array in Page)
 *
 * Una sola chiamata per entità in luogo dei 7 fan-out per-id per-tipo della
 * timeline (elimina l'N+1). Il record completo resta sulle getX singole.
 */

import type { Page } from '@crm/shared';
import { httpClient } from '../../api/httpClient';
import type { ActivitySummary } from './activityTypes';

export const activityApi = {
  /** GET bulk: tutte le attività collegate all'entità (className FQN, classPK). */
  getEntityActivities: (
    groupId: number,
    className: string,
    classPK: number,
  ): Promise<ActivitySummary[]> =>
    httpClient
      .get<Page<ActivitySummary>>(`/relationships/${groupId}/activities`, {
        params: { className, classPK },
      })
      .then((r) => r.data.items ?? []),
};
